import { ShaderStore } from "@babylonjs/core";
const name = "textureDepthVertexDeclaration";
const shader = `in vec4 textureDepths;out vec2 vUvs;flat out float depth;`;
ShaderStore.IncludesShadersStore[name] = shader;
export const textureDepthVertexDeclaration = { name, shader };
//# sourceMappingURL=textureDepthVertexDeclaration.js.map